import Modal from "react-modal";
import React from "react";







export default function ({modalIsOpen,Openchanger}){




    const customStyles = {
                overlay: {
              position: 'fixed',
                          zIndex: 1020,
                          top: 0,
                          left: 0,
                          width: '100vw',
                          height: '100vh',
                          background: 'rgba(0,0,0, 0.5)',
                          display: 'flex',
                          justifyContent: 'center',


            },

                  content: {
                   background: 'white',
                          width: '33rem',
                          maxWidth: 'calc(150vw - 2rem)',
                          maxHeight: 'calc(91vh - 2rem)',
                          overflowY: 'hidden',
                          position: 'relative',
                          border: '0px',
                          borderRadius: '0.3rem',
                          inset: '0px',




                  },


        };


            Modal.setAppElement('#root');




            let subtitle;
            function afterOpenModal() {
          }
           function closeModal() {
                Openchanger(false)

          }



             return(
                 <Modal
                        isOpen={modalIsOpen}
                        onAfterOpen={afterOpenModal}
                        ariaHideApp={false}
                        style={customStyles}
                        contentLabel="Example Modal"
                        backdrop= "static"

                      >

                          <div className={'container'} id={'mbody'}>
                              <div className={'title'}>
                                  <span className="close" onClick={closeModal}>&times;</span>
                                  <h6>نمونه عکس ارسالی</h6>

                                  <hr/>
                              </div>
                               <div className={'text-warning text-large'}>
                                   <p className={'text-danger'}>
                                       توجه :
                                   </p>
                                      <p className={'text-danger'}>
                                                                                
                                                                                عکس ارسالی باید بدون عینک توسط شخص دیگر برای عدم برعکس افتادن نوشته گرفته شود.

                                      </p>



                                  </div>

                               <div>
                                  <div className={'txp  pb-2'}>
                                      <p className={'text-info text-large'}>متن ارسالی :</p>
                                    <h6 className={'border-success border-5 text-large'}>
                                        اینجانب ........قصد معامله با سایت سیناتــتر به آدرس 
                                        sinatether.com
                                        

را دارم مدارک لازم جهت احراز هویت در این سایت ارسال گردیده است.ضمنا متعهد میشوم که حساب بنده تحت اختیار خودم میباشد و حساب به شخصی اجاره داده نشده است و خرید را برای خودم انجام میدهم
                                                                   (امضای شما) 
                                    </h6>

                                </div>

                            </div>

                              <div className={'text-center align-items-center'}>
                                  <img src={'images/selfiexample.png'} className={'w-75 h-75'}/>

                              </div>

                          </div>




                      </Modal>
             )

}